import {combineReducers} from "redux";
import resultVn1 from "./resultVn1";
import resultTn from "./resultTn";
import resultKh from "./resultKh";
///view

const resultDrawReducer = combineReducers({
    resultVn1,
    resultTn,
    resultKh
});
export default resultDrawReducer;